import Address, { AddressField } from '@components/form/Address/Address';
import * as F from '@modules/dictionary/DictionaryFields';
import * as C from '@modules/dictionary/_dictionaryColumns';
import { withProps } from 'recompose';

export const dictionaryTemplates = {
  // Places
  countries: {
    url: 'common/countries',
    title: 'Státy',
    formTitle: 'Nový stát',
    columns: [C.order, C.name, C.active, C.code],
    fields: [F.Order, F.Name, F.Code, F.Active]
  },
  regions: {
    url: 'common/regions',
    title: 'Kraje',
    formTitle: 'Nový kraj',
    columns: [C.order, C.name, C.active, C.code, C.country],
    fields: [F.Order, F.Name, F.Code, F.Country, F.Active]
  },
  counties: {
    url: 'common/counties',
    title: 'Okresy',
    formTitle: 'Nový okres',
    columns: [C.order, C.name, C.active, C.code, C.region],
    fields: [F.Order, F.Name, F.Code, F.Region, F.Active]
  },
  municipalities: {
    url: 'common/municipalities',
    title: 'Obce',
    formTitle: 'Nová obec',
    columns: [C.order, C.name, C.active, C.code, C.county],
    fields: [F.Order, F.Name, F.Code, F.County, F.Active]
  },
  'municipality-parts': {
    url: 'common/municipalityparts',
    title: 'Části obcí',
    formTitle: 'Nová část obce',
    columns: [C.order, C.name, C.active, C.code, C.municipality],
    fields: [F.Order, F.Name, F.Code, F.Municipality, F.Active]
  },
  streets: {
    url: 'common/streets',
    title: 'Ulice',
    formTitle: 'Nová ulice',
    columns: [C.order, C.name, C.active, C.code, C.municipality],
    fields: [F.Order, F.Name, F.Code, F.Municipality, F.Active]
  },
  places: {
    url: 'address/place',
    title: 'Vlastní místa',
    formTitle: 'Nové vlastní místo',
    columns: [C.order, C.name, C.active, C.fullAddress],
    fields: {
      Informace: [F.Order, F.Name, F.Active],
      Adresa: [withProps<any, any>({ name: 'address', component: Address, columnStyle: true })(AddressField)]
    }
  },

  // Employees
  'certificate-types': {
    url: 'hr/certificateTypes',
    title: 'Typy osvědčení',
    formTitle: 'Nový typ osvědčení',
    columns: [C.order, C.name, C.active, C.reminder, C.template],
    fields: [F.Order, F.Name, F.Template, F.Reminder, F.Active]
  },
  educations: {
    url: 'hr/educations',
    title: 'Vzdělání',
    formTitle: 'Nové vzdělání',
    columns: [C.order, C.name, C.educationType, C.active],
    fields: [F.Order, F.Name, F.EducationType, F.Active]
  },
  'work-positions': {
    url: 'hr/work-positions',
    title: 'Pracovní pozice',
    formTitle: 'Nová pracovní pozice'
  },

  // Events
  'event-types': {
    url: 'ed/types',
    title: 'Typy událostí',
    formTitle: 'Nový typ události',
    columns: [C.order, C.name, C.fullName, C.report, C.parentType, C.active],
    fields: [F.Order, F.NameWide, F.Report, F.ActiveWide, F.EventType]
  },
  'event-report-types': {
    url: 'ed/reportTypes',
    title: 'Způsoby oznámení',
    formTitle: 'Nový způsoby oznámení'
  },
  'event-resolutions': {
    url: 'ed/resolutions',
    title: 'Způsoby řešení',
    formTitle: 'Nový způsoby řešení'
  },
  'event-classifications': {
    url: 'ed/classifications',
    title: 'Uživatelská klasifikace',
    formTitle: 'Nová uživatelská klasifikace'
  },
  // Event Record Params
  'event-sps-record-rcase': {
    url: 'common/sps/record/rcase',
    title: 'Věci spisu',
    formTitle: 'Nová věc spisu'
  },
  'event-sps-document-marks': {
    url: 'common/sps/document/marks',
    title: 'Značky dokumentu',
    formTitle: 'Nová Značka dokumentu'
  },
  'event-sps-document-dcase': {
    url: 'common/sps/document/dcase',
    title: 'Věci dokumentu',
    formTitle: 'Nová věc dokumentu'
  },
  'event-sps-document-symbols': {
    url: 'common/sps/document/symbols',
    title: 'Spisové znaky dokumentu',
    formTitle: 'Nový spisový znak dokumentu',
    columns: [C.name, C.code, C.shreddingSymbol, C.shreddingPeriod, C.active],
    fields: [F.Name, F.Code, F.ShreddingSymbol, F.ShreddingPeriod, F.Active]
  },
  // Event Correspodences
  'event-correspodence-types': {
    url: 'ed/correspondence/types',
    title: 'Typy',
    formTitle: 'Nový typ'
  },
  'event-correspodence-offices': {
    url: 'ed/correspondence/offices',
    title: 'Úřady',
    formTitle: 'Nový úřad'
  },

  // Delicts
  'delict-types': {
    url: 'ed/delict/types',
    title: 'Typy přestupků',
    formTitle: 'Nový typ přestupku',
    columns: [
      C.order,
      C.name,
      C.fullName,
      C.law,
      C.amendment,
      C.paragraph,
      C.section,
      C.letter,
      C.pointOfLetter,
      C.description,
      C.points,
      C.parentType,
      C.active
    ],
    fields: [
      F.Order,
      F.Name,
      F.Law,
      F.Amendment,
      F.Paragraph,
      F.Section,
      F.Letter,
      F.PointOfLetter,
      F.Description,
      F.Points,
      F.DelictType,
      F.ActiveWide
    ]
  },
  'delict-discoveries': {
    url: 'ed/delict/discoveries',
    title: 'Způsoby zjištění',
    formTitle: 'Nový způsob zjištění'
  },
  'delict-resolutions-so': {
    url: 'ed/delict/resolution-sos',
    title: 'Správní orgány',
    formTitle: 'Nový správní orgán'
  },
  'delict-violations': {
    url: 'ed/delict/violations',
    title: 'Porušení',
    formTitle: 'Nové porušení',
    columns: [C.order, C.name, C.violationLaw, C.delictLaw, C.active],
    fields: [F.Order, F.Name, F.ViolationLaw, F.DelictLaw, F.Active]
  },

  // Dogs
  'dog-breeds': {
    url: 'dg/breeds',
    title: 'Plemena psů',
    formTitle: 'Nové psí plemeno',
    fields: [F.Order, F.Name, F.Active]
  },
  'dog-colors': {
    url: 'dg/colors',
    title: 'Barvy psů',
    formTitle: 'Nová barva psa',
    fields: [F.Order, F.Name, F.Active]
  },

  // Bicycles
  'bicycles-brands': {
    url: 'bi/brands',
    title: 'Značky kol',
    formTitle: 'Nová značka kola',
    fields: [F.Order, F.Name, F.Active]
  },
  'bicycles-colors': {
    url: 'bi/colors',
    title: 'Značky kol',
    formTitle: 'Nová barva kola',
    fields: [F.Order, F.Name, F.Active]
  },

  // Warehouses
  'warehouse-suppliers': {
    url: 'wa/suppliers',
    title: 'Dodavatelé',
    formTitle: 'Nový dodavatel',
    columns: [C.order, C.name, C.idNumber, C.contact, C.phoneNumber, C.email, C.active, C.fullAddress],
    fields: {
      Informace: [F.Order, F.Name, F.IdNumber, F.Contact, F.PhoneNumber, F.Email, F.Active],
      Adresa: [F.Address]
    }
  },
  'warehouse-warehouses': {
    url: 'wa/warehouses',
    title: 'Sklady',
    formTitle: 'Nový sklad'
  },
  'warehouse-card-categories': {
    url: 'wa/cardCategories',
    title: 'Kategorie karet',
    formTitle: 'Nová kategorie karet',
    columns: [C.name, C.active],
    fields: [F.Name, F.Active]
  },
  'warehouse-measure-units': {
    url: 'wa/measure-units',
    title: 'Měrné jednotky',
    formTitle: 'Nová měrná jednotka'
  },
  'warehouse-disposal-types': {
    url: 'wa/disposal-types',
    title: 'Typy likvidace',
    formTitle: 'Nový typ likvidace'
  },

  // Vehicles
  'vehicle-types': {
    url: 'wv/types',
    title: 'Typy vozů',
    formTitle: 'Nový typ vozu'
  },
  'vehicle-brands': {
    url: 'wv/brands',
    title: 'Značky vozů',
    formTitle: 'Nová značka vozu',
    columns: [C.order, C.name, C.active],
    fields: [F.Order, F.Name, F.Active]
  },
  'vehicle-colors': {
    url: 'wv/colors',
    title: 'Barvy vozů',
    formTitle: 'Nová barva vozu'
  },
  'vehicle-calls': {
    url: 'cl/callsign',
    title: 'Volací znaky',
    formTitle: 'Nový volací znak'
  },
  'service-vehicles': {
    url: 'cl/vehicles',
    title: 'Služební vozidla',
    formTitle: 'Nové služební vozidlo',
    columns: [
      C.registrationNumber,
      C.vinNumber,
      C.brand,
      C.type,
      C.color,
      C.mileage,
      C.fuelCosts,
      C.repairCosts,
      C.fuelType,
      C.callSign,
      C.fuelConsumption,
      C.nextStkTest,
      C.oilType,
      C.tireSize,
      C.lastInspection,
      C.nextInspection,
      C.lastGeneralInspection,
      C.generalInspectionMileage,
      C.generalInspectionDate
    ],
    tabs: {
      Vozidlo: [F.ServiceVehicleVehicle],
      Ostatní: {
        Náklady: [F.Mileage, F.FuelConsumption, F.FuelCosts, F.RepairCosts],
        Typy: [F.CallSign, F.FuelType, F.OilType, F.TireSize]
      },
      Prohlídka: [
        F.LastInspection,
        F.nextInspection,
        F.NextStkTest,
        F.LastGeneralInspection,
        F.GeneralInspectionMileage,
        F.GeneralInspectionDate
      ]
    }
  },
  'task-states': {
    url: 'ts/task-states',
    title: 'Stavy',
    formTitle: 'Nový stav'
  },
  // Wanted
  'wantedPerson-reason': {
    url: 'wp/reasons',
    title: 'Důvod pátrání',
    formTitle: 'Nový důvod pátrání',
    columns: [C.order, C.name, C.active],
    fields: [F.Order, F.Name, F.Active]
  },

  // Sequences
  'number-sequences': {
    url: 'sequences',
    title: 'Číselné řady',
    formTitle: 'Nová číselná řada',
    columns: [C.order, C.name, C.format, C.counter, C.active],
    fields: [F.Order, F.Name, F.Format, F.Counter, F.Active]
  },

  departments: {
    url: 'ed/departments',
    title: 'Okrsky',
    formTitle: 'Nový okrsek'
  },

  'work-plan': {
    url: 'hr/workplan/evidence/types',
    title: 'Typy pracovních dnů',
    formTitle: 'Nový typ pracovních dnů',
    columns: [C.order, C.name, C.active, C.symbol],
    fields: [F.Order, F.Name, F.Active, F.Symbol]
  },

  'operational-warehouses': {
    url: 'owa/warehouse',
    title: 'Operační sklady',
    formTitle: 'Nový operační sklad'
  },

  'card-categories': {
    url: 'owa/item/category',
    title: 'Kategorie karet',
    formTitle: 'Nová kategorie karet'
  },

  stations: {
    url: 'ed/stations',
    title: 'Pracoviště',
    formTitle: 'Nové pracoviště',
    columns: [C.order, C.name, C.stationCode, C.active],
    fields: [F.Order, F.Name, F.StationCode, F.Active]
  }
};



// WEBPACK FOOTER //
// ./src/modules/dictionary/_dictionaryTemplates.ts